export default __webpack_public_path__ + "static/SR France - Fiche de Données Sécurité - Burnt Sugar (Liquide)-039d004e9ad39e01ee653c5b6f5a673a.pdf";